import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import { aliasOf as r } from "../../core/accessorSupport/decorators/aliasOf.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { property as t } from "../../core/accessorSupport/decorators/property.js";
import { subclass as o } from "../../core/accessorSupport/decorators/subclass.js";
import s from "../Widget.js";
import a from "./FeatureContent/FeatureContentViewModel.js";
import { shouldOpenInNewTab as i } from "./support/featureUtils.js";
import { isWidget as d } from "../support/widget.js";
import { tsx as n } from "../support/jsxFactory.js";
var c = {
  base: "esri-feature-content",
  loaderContainer: "esri-feature-content__loader-container",
  loader: "esri-feature-content__loader"
};

var l = /*#__PURE__*/function (_s) {
  _inherits(l, _s);

  var _super = _createSuper(l);

  function l(e, r) {
    var _this;

    _classCallCheck(this, l);

    _this = _super.call(this, e, r), _this.creator = null, _this.graphic = null, _this.viewModel = null, _this._addTargetToAnchors = function (e) {
      Array.from(e.querySelectorAll("a")).forEach(function (e) {
        i(e.href) && !e.hasAttribute("target") && e.setAttribute("target", "_blank");
      });
    };
    return _this;
  }

  _createClass(l, [{
    key: "renderLoading",
    value: function renderLoading() {
      return n("div", {
        class: c.loaderContainer,
        key: "loader"
      }, n("div", {
        class: c.loader
      }));
    }
  }, {
    key: "renderCreated",
    value: function renderCreated() {
      var e;
      var r = null == (e = this.viewModel) ? void 0 : e.created;
      return r ? r instanceof HTMLElement ? n("div", {
        key: r,
        bind: r,
        afterCreate: this._attachToNode
      }) : d(r) ? n("div", {
        key: r
      }, !r.destroyed && r.render()) : n("div", {
        key: r,
        innerHTML: r,
        afterCreate: this._addTargetToAnchors
      }) : null;
    }
  }, {
    key: "render",
    value: function render() {
      var e;
      var r = null == (e = this.viewModel) ? void 0 : e.state;
      return n("div", {
        class: c.base
      }, "loading" === r ? this.renderLoading() : this.renderCreated());
    }
  }, {
    key: "_attachToNode",
    value: function _attachToNode(e) {
      var r = this;
      e.appendChild(r);
    }
  }]);

  return l;
}(s);

e([r("viewModel.creator")], l.prototype, "creator", void 0), e([r("viewModel.graphic")], l.prototype, "graphic", void 0), e([t({
  type: a
})], l.prototype, "viewModel", void 0), l = e([o("esri.widgets.Feature.FeatureContent")], l);
var p = l;
export { p as default };